module.exports = __webpack_public_path__ + "static/img/govcard_02.7f5c104a.svg";